import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import Card from "../../../components/Card";
import { postApiCall } from "../../../service/httpCall";
import { API_NOTIFICATION_CREATE } from "../../../service/url";
import { ROUTES } from "../../../utilities/constant";

const NotificationCreate = () => {
    const navigate = useNavigate();
    const [type, setType] = useState("");
    const [description, setDescription] = useState("");
    const [status, setStatus] = useState(1);
    const [isGeneral, setIsGeneral] = useState(false);
    const [loading, setLoading] = useState(false);

    const submitForm = () => {
        if (!type || !description || type?.trim()?.length === 0 || description?.trim()?.length === 0) return toast.warning("Fields are required");
        
        setLoading(true);
        const payload = { notification_type: type, description, status: Number(status), is_general: isGeneral };

        postApiCall(API_NOTIFICATION_CREATE, payload)
            .then(() => {
                toast.success("Created successfully");
               setTimeout(() => navigate(`/${ROUTES.NOTIFICATION.LIST}`), 1000);
            })
             .catch((err) => {
                       const errorMsg = err|| "Something went wrong";
                    toast.error(errorMsg);  });             
    };

    return (
        <Card>
            <Card.Header><h4>Create Notification</h4></Card.Header>
            <Card.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Title <span className="text-danger">*</span></Form.Label>
                        <Form.Control placeholder="e.g. System Alert" onChange={(e) => setType(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Description <span className="text-danger">*</span>  </Form.Label>
                        <Form.Control as="textarea" rows={3} onChange={(e) => setDescription(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Check 
                            type="checkbox"
                            id="is-general"
                            label="Is General Notification"
                            checked={isGeneral}
                            onChange={(e) => setIsGeneral(e.target.checked)}
                        />
                    </Form.Group>
                    <Button onClick={submitForm} disabled={loading}>{loading ? "Saving..." : "Save"}</Button>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default NotificationCreate;